import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import ConfigurationContext from 'UserRegistration/contexts/ConfigurationContext';
import PublicBillingInformation from 'UserRegistration/components/RegistrationSteps/BillingInformation/PublicBillingInformation';
import AddContactBillingInformation from 'UserRegistration/components/RegistrationSteps/BillingInformation/AddContactBillingInformation';

/**
 * Displays the Add Contact version of the Billing Information section.
 * 
 * @param {object} props 
 */
function BillingInformation(props) {

    const { componentConfig } = useContext(ConfigurationContext);

    const renderBillingInformationAccordingToContext = () => {

        switch(componentConfig.context) {
            case 'ADD_CONTACT':
                return ( <AddContactBillingInformation {...props} />);
            case 'PUBLIC_REGISTRATION':
                return ( <PublicBillingInformation {...props} />);
            default:
                return ( null );
        }
    }

    return renderBillingInformationAccordingToContext();

}

BillingInformation.propTypes = {
    /** A reference to the Formik component. */
    formikRef: PropTypes.any,
    /** The total number of configurable sections currently loaded in the instance of UserRegistration. */
    sectionCount: PropTypes.number,
    /** The position of this section in relation to other sections in the entire instance of UserRegistration. */
    sectionNumber: PropTypes.number
};

export default BillingInformation;